import axios from "axios";

export const state = {
    runningloans: [],
};

export const getters = {
    runningloans: state => state.runningloans,
};

export const mutations = {
    setRunningLoans(state, newValue) {
        state.runningloans = newValue
    },
};

export const actions = {
    async fetchRunningLoans({ commit }) {
        await axios.get('/runningloans').then(res => {
            commit('setRunningLoans', res.data.runningloans)
        })
    },
    async filterRunningLoans({commit}, {datefrom,dateto}) { 
        let formData = new FormData();
        formData.append("datefrom", datefrom);
        formData.append("dateto", dateto);
        let url = "/filterrunningloans";
        await axios.post(url, formData).then((response) => {
            commit('setRunningLoans', response.data.runningloans)
        })
    },
};
